import * as gallery from "./gallery";
import * as modal from "./modal";
import * as stickable from "./stickable-bottom"

export type ModalHandler = modal.ModalHandler;
export type GalleryHandler = gallery.GalleryHandler;

export namespace Overlay {
  export const Gallery = gallery.default;
  export const Modal = modal.default;
  export const ModalTrigger = modal.ModalTrigger;
  export const ModalContent = modal.ModalContent;
  export const ModalFooter = modal.ModalFooter;
  export const StickableBottom = stickable.default;
  export const StickableContent = stickable.Content;
  export const StickableResume = stickable.Resume;
}
